module.exports = __webpack_public_path__ + "img/carpet.9dd873ce.png";